import { AppState, NamedTagGroup } from "./AppState";

export class AppStateReadableSerializer {
	static stateToReadable(
		appState: AppState,
		asHtml: boolean = true
	): string | null {
		let readable = "";
		const emptyLine = asHtml ? "<br><br>" : "\n\n";
		appState.groups.forEach(
			group =>
				(readable +=
					group.name + emptyLine + group.tags.join(" ") + emptyLine)
		);
		return readable;
	}

	static readableToState(readable: string): AppState | null {
		let groups: NamedTagGroup[] = [];

		let group: NamedTagGroup | null = null;
		for (let line of readable
			.replace(/\r\n/g, "\n")
			.split("\n")
			.map(l => l.trim())
			.filter(l => l.length > 0)) {
			if (line[0] === "#") {
				if (group) {
					let thisGroup = group as NamedTagGroup;
					thisGroup.tags = thisGroup.tags.concat(
						line
							.replace(/ /gi, "")
							.split("#")
							.filter(t => t.length > 0)
							.map(t => "#" + t)
					);
				}
			} else {
				group = { name: line, tags: [] } as NamedTagGroup;
				groups.push(group as NamedTagGroup);
			}
		}

		if (groups.length > 0) {
			return new AppState(groups);
		} else {
			return null;
		}
	}
}
